export const BASE_URL = "https://msmestores.com/api/v1/buyer/";
// export const BASE_URL = "http://localhost/indainmsme_api/api/v1/buyer/";
export const INDIAN_MSME_USER_TOKEN = "@INDIAN_MSME:USER_TOKEN";
export const INDIAN_MSME_USER_ID = "@INDIAN_MSME:USER_ID";
export const INDIAN_MSME_USER_TYPE = "@INDIAN_MSME:USER_TYPE";
export const LOGO = require("../assets/logo.png");
export const PO_CSV_FILE = require("../assets/excel/po_product_sample.xlsx");
export const PAYMENT_QR = require("../assets/paymentQr/abhhyam_qr.jpg");
export const LOGIN_BG = require("../assets/login_bg.png");
export const CANCELLED = require("../assets/cancelled.png");
export const WEBSITE = require("../assets/website.png");
export const GMAIL = require("../assets/gmail.png");
export const PHONE = require("../assets/phone.png");
export const CARDLOGO = require("../assets/card_logo.png");
export const CART = require("../assets/empty_cart.png");
export const BUYER_HIDDEN_MESSAGE_ID = "BUYER_HIDDEN_MESSAGE_ID";
